import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const H1Headline = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill={color} xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 3.5C3 3.22386 2.77614 3 2.5 3C2.22386 3 2 3.22386 2 3.5V12.5C2 12.7761 2.22386 13 2.5 13C2.77614 13 3 12.7761 3 12.5V8.5H8V12.5C8 12.7761 8.22386 13 8.5 13C8.77614 13 9 12.7761 9 12.5V3.5C9 3.22386 8.77614 3 8.5 3C8.22386 3 8 3.22386 8 3.5V7.5H3V3.5ZM13.4617 6.86364C13.4617 6.48708 13.1564 6.18182 12.7798 6.18182H12.6864C12.5378 6.18182 12.3924 6.22452 12.2673 6.30483L11.1999 6.99057C11.0833 7.0655 11.0128 7.19461 11.0128 7.33323C11.0128 7.65494 11.3682 7.84965 11.6393 7.67646L12.3736 7.20739H12.4077V12.473C12.4077 12.7641 12.6436 13 12.9347 13C13.2257 13 13.4617 12.7641 13.4617 12.473V6.86364Z"
        />
      </svg>
    )
  },
)

export default H1Headline
